/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ico-camera-flash-active': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M13.715.11c-.14.094-3.011 4.63-8.133 12.847C5.056 13.8 5 13.91 5 14.105c0 .258.124.482.337.613.148.09.24.093 3.05.094h2.898L10.24 18.98c-.575 2.293-1.045 4.248-1.045 4.346 0 .525.64.86 1.076.563.12-.08 1.018-1.479 3.737-5.822 5.537-8.841 4.976-7.92 4.976-8.17a.704.704 0 00-.337-.615c-.148-.09-.24-.093-3.05-.093h-2.898l1.045-4.17c.575-2.293 1.045-4.248 1.045-4.346 0-.522-.64-.858-1.074-.563z" _fill="#fff"/>'
  }
})
